import { toast } from "sonner";

// Copie sûre : pas de rejet non géré si le presse-papiers est refusé (Safari, permissions).
export const copyToClipboard = async (text, message = "Lien copié.") => {
  try {
    await navigator.clipboard.writeText(text);
    if (message) toast.success(message);
    return true;
  } catch (e) {
    toast.error("Copie impossible — sélectionnez le texte manuellement.");
    return false;
  }
};
